
























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import ImageUpload from "@/components/common/edit/ImageUpload.vue";
import VideoUpload from "@/components/common/edit/VideoUpload.vue";

@Component({
  components: {
    "image-upload": ImageUpload,
    "video-upload": VideoUpload,
  }
})
export default class FieldButton extends Vue {
  @Prop({ required: true })
  iconImg!: string;

  @Prop({ required: true })
  type!: string;

  @Prop({ required: true })
  text!: string;

  @Prop()
  ownStyle!: object;

  @Getter("section")
  section!: object;

  handleClick() {
    this.$emit("click");
  }

  handleUploadImage(imgUrl: string) {
    this.$emit("upload", imgUrl);
  }
}
